import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/img3.png';
const _hoisted_1 = {
  class: "container long-container wow animate__animated animate__fadeInUp",
  "data-wow-duration": "2s",
  "data-wow-delay": "0.1s"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "right-news"
};
const _hoisted_4 = {
  class: "right-time"
};
const _hoisted_5 = {
  class: "day"
};
const _hoisted_6 = {
  class: "news-date"
};
const _hoisted_7 = {
  class: "right-news-content"
};
const _hoisted_8 = {
  class: "right-news-title"
};
const _hoisted_9 = {
  class: "right-news-text"
};
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const newsList = ref([{
      day: "29",
      date: '2023.04',
      title: '最高50-25！福泰隆超市助力政府消费券可...',
      content: '金华福泰隆5员消费券，可与金华普惠券叠加使用。'
    }, {
      day: "26",
      date: '2023.04',
      title: '五一更疯狂，码上领补贴',
      content: '“浙里来消费·嗨购金兔年”首届“码上购车补贴”暨全市汽车品牌向百人企业发放叠加购车补贴。'
    }, {
      day: "19",
      date: '2023.04',
      title: '买立马电动车享“立马”省钱',
      content: '2023年1 月1日起非标电动自行车不能上路啦!快来挑选一辆更安全、更轻便的新国标电动车吧~'
    }, {
      day: "07",
      date: '2023.04',
      title: '春暖花开季，出行正当时，打车优惠券来啦',
      content: '春暖花已渐开，滴滴打车出行发放优惠券啦,浙里金消用户专属福利,小伙伴们赶紧看过来。'
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "us-title"
      }, "LATEST NEWS", -1)), _cache[3] || (_cache[3] = _createElementVNode("h3", {
        class: "title"
      }, "最新咨询", -1)), _createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"left-news\" data-v-0d8001c8><img src=\"" + _imports_0 + "\" alt=\"\" style=\"width:550px;height:350px;\" data-v-0d8001c8><div class=\"news-item\" data-v-0d8001c8><div class=\"time\" data-v-0d8001c8><div class=\"day\" data-v-0d8001c8> 30 </div><div class=\"bd-line\" data-v-0d8001c8></div><div class=\"news-date\" data-v-0d8001c8>2023.04</div></div><div class=\"news-content\" data-v-0d8001c8><div class=\"news-title\" data-v-0d8001c8>信用金上线特惠首借年利率3.6%单利</div><div class=\"news-text\" data-v-0d8001c8>浙里金消联合宁波银行特推出专属于金华人的信用金贷款，首期利息仅需3.6%起（单利）， 一起放肆花吧~</div></div></div></div>", 1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "right-news-item flex",
          key: item.title
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.day), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "bd-line"
        }, null, -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(item.date), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1)])]);
      }), 128))])])]);
    };
  }
};